//React Components and Hooks
import React from 'react';
//Material UI functions
import { makeStyles } from '@mui/styles';
//Material UI Components
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';


const useStyles = makeStyles((theme) => ({

}));

const Delete = (props)=>{

    return(
        <Tooltip title={props.tooltip}>
            <IconButton onClick={props.clickFunction}>
                <DeleteIcon color="error" fontSize="small"/>
            </IconButton>
        </Tooltip>
    )
}

export default Delete;